// 油品调整
import { request,pretty } from '@/utils/request' 
export const addAppInfo = (item)=>{
  return pretty(request.post("/api/AppInfo/Add",{...item}));
}
export const deleteAppInfo = (item)=>{
  return pretty(request.post(`/api/AppInfo/Delete?ids=${item}`));
}
export const detailAppInfo = (item)=>{
  return pretty(request.get(`/api/AppInfo/Detail?id=${item}`));
}
export const editAppInfo = (item)=>{
  return pretty(request.post("/api/AppInfo/Edit",{...item}));
}
export const listAppInfo = (item)=>{
  return pretty(request.get(`/api/AppInfo/List?pageSize=${item?.pageSize?(item?.pageSize):10}&pageIndex=${item?.pageIndex?(item?.pageIndex):1}`));
}